import { IRecurringPayment, IHistoryRecurringPayment } from "../entryes/atPay/types/RecurringPayment";
import http from "./client";

// const studenList = {
//   "data": [
//       {
//           "id": 14,
//           "price": 1000,
//           "user": {
//               "id": 12644,
//               "name": "\u0410\u0440\u0438\u043d\u0430\u0439\u0439\u0439\u0439",
//               "lastName": "",
//               "email": "2student@1iu.ru",
//               "phone": "",
//               "avatar": "",
//               "isOnline": false
//           },
//           "status": "active",
//           "canDisable": true,
//           "totalPaymentsCount": 1,
//           "firstPaymentDate": "2024-12-09T11:04:00+03:00",
//           "nextPaymentDate": "2025-01-09T11:04:00+03:00",
//           "product": {
//               "id": 3,
//               "type": "course",
//               "name": "\u041a\u0443\u0440\u0441 \u0441\u043e \u0441\u0442\u0430\u0442\u0443\u0441\u0430\u043c\u0438 \u0443\u0447\u0435\u043d\u0438\u043a\u043e\u0432 \u0438 \u0441\u0442\u0430\u0442\u0443\u0441\u0430\u043c\u0438 \u0443\u0440\u043e\u043a\u043e\u0432 \u0438 \u0434\u043b\u0438\u043d\u043d\u044b\u043c\u0438 \u043d\u0430\u0437\u0432\u0430\u043d\u0438\u044f\u043c\u0438 \u0437\u0430\u0434\u0430\u043d\u0438\u0439 :  \u0410\u0440\u043a\u0442\u0438\u043a\u0430 \u0022\u0435\u0434\u0438\u043d\u044b\u0439 \u0444\u0438\u0437\u0438\u043a\u043e-\u0433\u0435\u043e\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043a\u0438\u0439 \u0440\u0430\u0439\u043e\u043d \u0417\u0435\u043c\u043b\u0438, \u043f\u0440\u0438\u043c\u044b\u043a\u0430\u044e\u0449\u0438\u0439 \u043a \u0421\u0435\u0432\u0435\u0440\u043d\u043e\u043c\u0443 \u043f\u043e\u043b\u044e\u0441\u0443 \u0438 \u0432\u043a\u043b\u044e\u0447\u0430\u044e\u0449\u0438\u0439 \u043e\u043a\u0440\u0430\u0438\u043d\u044b \u043c\u0430\u0442\u0435\u0440\u0438\u043a\u043e\u0432 \u0415\u0432\u0440\u0430\u0437\u0438\u0438 \u0438 \u0421\u0435\u0432\u0435\u0440\u043d\u043e\u0439 \u0410\u043c\u0435\u0440\u0438\u043a\u0438 \u0022!\u0022\u2116;%:?*@#$%^\u0026*",
//               "plan": "\u0022\u042d\u043a\u043e\u043d\u043e\u043c\u0022"
//           }
//       },
//       {
//           "id": 10,
//           "price": 556,
//           "user": {
//               "id": 12594,
//               "name": "\u0418\u0433\u043e\u0440\u044c",
//               "lastName": "\u0418\u0432\u0430\u043d\u043e\u0432",
//               "email": "admin22@1iu.ru",
//               "phone": "",
//               "avatar": "",
//               "isOnline": false
//           },
//           "status": "active",
//           "canDisable": false,
//           "totalPaymentsCount": 1,
//           "firstPaymentDate": "2024-11-14T14:32:13+03:00",
//           "nextPaymentDate": "2024-12-21T00:00:00+03:00",
//           "product": {
//               "id": 269254,
//               "type": "course",
//               "name": "\u0422\u0435\u0441\u0442 \u0430\u0443\u0434\u0438\u043e \u0432 \u0414\u0417",
//               "plan": "\u0442\u0435\u0441\u0442"
//           }
//       },
//       {
//           "id": 11,
//           "price": 10900,
//           "user": {
//               "id": 12594,
//               "name": "\u0418\u0433\u043e\u0440\u044c",
//               "lastName": "\u0418\u0432\u0430\u043d\u043e\u0432",
//               "email": "admin22@1iu.ru",
//               "phone": "",
//               "avatar": "",
//               "isOnline": false
//           },
//           "status": "cancel",
//           "totalPaymentsCount": 1,
//           "firstPaymentDate": "2024-11-14T14:32:45+03:00",
//           "nextPaymentDate": "2024-12-12T00:00:00+03:00",
//           "product": {
//               "id": 315,
//               "type": "group",
//               "name": "\u041f\u043e\u0434\u043f\u0438\u0441\u043a\u0430 ATPay",
//               "plan": "\u0422\u0430\u0440\u0438\u0444 \u21161"
//           }
//       },
//       {
//           "id": 8,
//           "price": 2000,
//           "user": {
//               "id": 12557,
//               "name": "\u0438\u043d\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043b\u044c\u043d\u044b\u0439",
//               "lastName": "",
//               "email": "gfhhh@fsgfs.ru",
//               "phone": "",
//               "avatar": "",
//               "isOnline": false
//           },
//           "status": "active",
//           "totalPaymentsCount": 1,
//           "firstPaymentDate": "2024-10-30T17:41:08+03:00",
//           "nextPaymentDate": "2024-11-30T17:41:08+03:00",
//           "product": {
//               "id": 269705,
//               "type": "course",
//               "name": "\u0414\u043b\u044f \u0440\u0435\u043a\u0443\u0440\u0440\u0435\u043d\u0442\u043e\u0432",
//               "plan": "\u0440\u0435\u043a\u0443\u0440\u0440\u0435\u043d\u0442"
//           }
//       },
//       {
//           "id": 12,
//           "price": 10900,
//           "user": {
//               "id": 12594,
//               "name": "\u0418\u0433\u043e\u0440\u044c",
//               "lastName": "\u0418\u0432\u0430\u043d\u043e\u0432",
//               "email": "admin22@1iu.ru",
//               "phone": "",
//               "avatar": "",
//               "isOnline": false
//           },
//           "status": "cancel",
//           "totalPaymentsCount": 2,
//           "firstPaymentDate": "2024-09-25T14:32:45+03:00",
//           "nextPaymentDate": "2024-11-25T14:32:45+03:00",
//           "product": {
//               "id": 315,
//               "type": "group",
//               "name": "\u041f\u043e\u0434\u043f\u0438\u0441\u043a\u0430 ATPay",
//               "plan": "\u0422\u0430\u0440\u0438\u0444 \u21161"
//           }
//       },
//       {
//           "id": 13,
//           "price": 10900,
//           "user": {
//               "id": 12594,
//               "name": "\u0418\u0433\u043e\u0440\u044c",
//               "lastName": "\u0418\u0432\u0430\u043d\u043e\u0432",
//               "email": "admin22@1iu.ru",
//               "phone": "",
//               "avatar": "",
//               "isOnline": false
//           },
//           "status": "active",
//           "totalPaymentsCount": 2,
//           "firstPaymentDate": "2024-09-25T14:32:45+03:00",
//           "nextPaymentDate": "2024-11-25T14:32:45+03:00",
//           "product": {
//               "id": 315,
//               "type": "group",
//               "name": "\u041f\u043e\u0434\u043f\u0438\u0441\u043a\u0430 ATPay",
//               "plan": "\u0422\u0430\u0440\u0438\u0444 \u21161"
//           }
//       },
//       {
//           "id": 7,
//           "price": 2000,
//           "user": {
//               "id": 12376,
//               "name": "hdekf",
//               "lastName": "",
//               "email": "gfge@sfsf.ru",
//               "phone": "",
//               "avatar": "",
//               "isOnline": false
//           },
//           "status": "active",
//           "totalPaymentsCount": 1,
//           "firstPaymentDate": "2024-09-09T16:14:19+03:00",
//           "nextPaymentDate": "2024-10-09T20:21:00+03:00",
//           "product": {
//               "id": 269705,
//               "type": "course",
//               "name": "\u0414\u043b\u044f \u0440\u0435\u043a\u0443\u0440\u0440\u0435\u043d\u0442\u043e\u0432",
//               "plan": "\u0440\u0435\u043a\u0443\u0440\u0440\u0435\u043d\u0442"
//           }
//       },
//       {
//           "id": 6,
//           "price": 2000,
//           "user": {
//               "id": 12375,
//               "name": "jthtrhg",
//               "lastName": "",
//               "email": "htgtrhg@fsfssf.ru",
//               "phone": "",
//               "avatar": "",
//               "isOnline": false
//           },
//           "status": "cancel",
//           "totalPaymentsCount": 1,
//           "firstPaymentDate": "2024-09-09T16:13:21+03:00",
//           "nextPaymentDate": "2024-10-09T16:13:21+03:00",
//           "product": {
//               "id": 269705,
//               "type": "course",
//               "name": "\u0414\u043b\u044f \u0440\u0435\u043a\u0443\u0440\u0440\u0435\u043d\u0442\u043e\u0432",
//               "plan": "\u0440\u0435\u043a\u0443\u0440\u0440\u0435\u043d\u0442"
//           }
//       },
//       {
//           "id": 5,
//           "price": 2000,
//           "user": {
//               "id": 12374,
//               "name": "tryry",
//               "lastName": "",
//               "email": "qrwqwr@fssf.ru",
//               "phone": "",
//               "avatar": "",
//               "isOnline": false
//           },
//           "status": "cancel",
//           "totalPaymentsCount": 1,
//           "firstPaymentDate": "2024-09-09T15:01:18+03:00",
//           "nextPaymentDate": "2024-09-16T18:01:18+03:00",
//           "product": {
//               "id": 269705,
//               "type": "course",
//               "name": "\u0414\u043b\u044f \u0440\u0435\u043a\u0443\u0440\u0440\u0435\u043d\u0442\u043e\u0432",
//               "plan": "\u0440\u0435\u043a\u0443\u0440\u0440\u0435\u043d\u0442"
//           }
//       }
//   ],
//   "paginator": {
//       "countItems": 9
//   }
// } 

export async function list(search: string, offset: number = 0, limit: number = 10): Promise<{paginator: { countItems: number }, data: Array<IRecurringPayment>}> {
  const res = await http.get('/api/v2/recurrents', {
     params: {
       search,
       offset,
       limit
     }
   })
  return res.data;
}

export async function get(id: number) {
  const res = await http.get(`/api/v2/recurrents/${id}`);
  return res.data;
}

export async function update(recurringPayment: Partial<IRecurringPayment>) {
  const res = await http.put(`/api/v2/recurrents/${recurringPayment.id}`, recurringPayment);

  return res.data;
}

export async function history(id: number, search: string, offset: number = 0, limit: number = 10): Promise<{paginator: { countItems: number }, data: Array<IHistoryRecurringPayment>}> {
  const res = await http.get(`/api/v2/recurrents/${id}/history`, {
     params: {
       offset,
       limit
     }
  })

  return res.data;
}

const studentRecurrings = {
  list,
  get,
  update,
  history,
}

export default studentRecurrings;